/* Ürün yorum yıldızı hizalama */
(function () {
  const content = document.querySelector('.product__content');
  const rating = document.querySelector('.spr-starrating');
  if (!content || !rating) return;

  if (content.classList.contains('text-center')) {
    rating.style.justifyContent = 'center';
  } else if (content.classList.contains('text-right')) {
    rating.style.justifyContent = 'flex-end';
  } else if (content.classList.contains('text-left')) {
    rating.style.justifyContent = 'flex-start';
  }
})();

/* Kairos Sticky Add To Cart v4 — varyant + görsel senkronizasyonu */
document.addEventListener('DOMContentLoaded', function () {
  /*
   * Mobilde tema sticky ürün özetini/görselini gizlese bile
   * seçili varyanta ait küçük görsel görünür kalsın.
   */
  if (!document.getElementById('kairos-sticky-atc-v4-style')) {
    const stickyStyle = document.createElement('style');
    stickyStyle.id = 'kairos-sticky-atc-v4-style';
    stickyStyle.textContent = `
      [data-kairos-sticky-atc] .kairos-sticky-atc__image {
        display: block;
        object-fit: contain;
        background: #fff;
      }

      @media screen and (max-width: 749px) {
        [data-kairos-sticky-atc] .kairos-sticky-atc__summary {
          display: flex !important;
          align-items: center !important;
          justify-content: flex-start !important;
          flex: 0 0 46px !important;
          width: 46px !important;
          min-width: 46px !important;
          max-width: 46px !important;
          margin: 0 8px 0 0 !important;
          padding: 0 !important;
          overflow: visible !important;
        }

        [data-kairos-sticky-atc] .kairos-sticky-atc__image {
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
          width: 46px !important;
          height: 46px !important;
          min-width: 46px !important;
          max-width: 46px !important;
          margin: 0 !important;
          padding: 3px !important;
          border: 1px solid #e8ddd2 !important;
          border-radius: 8px !important;
          object-fit: contain !important;
          background: #fff !important;
        }

        [data-kairos-sticky-atc]
        .kairos-sticky-atc__summary
        .kairos-sticky-atc__text {
          display: none !important;
        }
      }
    `;

    document.head.appendChild(stickyStyle);
  }

  document
    .querySelectorAll('[data-kairos-sticky-atc]')
    .forEach(initKairosStickyBar);

  function initKairosStickyBar(bar) {
    const section =
      bar.closest('.main-product') ||
      document.querySelector('.main-product');

    if (!section) return;

    const form =
      bar.querySelector('[data-kairos-sticky-form]');

    const variantInput =
      bar.querySelector('[data-kairos-variant-id]');

    const submitButton =
      bar.querySelector('[data-kairos-sticky-submit]');

    const priceEl =
      bar.querySelector('[data-kairos-sticky-price]');

    const imageRoot =
      bar.querySelector('[data-kairos-sticky-image]') ||
      bar.querySelector('.kairos-sticky-atc__image');

    const variantsScript =
      bar.querySelector('[data-kairos-sticky-variants]');

    const stickySelects = Array.from(
      bar.querySelectorAll('[data-kairos-option-index]')
    ).sort(function (a, b) {
      return (
        Number(a.dataset.kairosOptionIndex) -
        Number(b.dataset.kairosOptionIndex)
      );
    });

    if (
      !form ||
      !variantInput ||
      !submitButton ||
      !variantsScript
    ) {
      return;
    }

    let variants = [];

    try {
      variants = JSON.parse(
        variantsScript.textContent || '[]'
      );
    } catch (error) {
      console.error(
        'Kairos varyant JSON hatası:',
        error
      );

      return;
    }

    if (!variants.length) return;

    let preferredOptions = [];
    let syncing = false;
    let pending = null;
    let token = 0;
    let observer = null;
    let lastIntentIndex = -1;
    let lastIntentAt = 0;

    function normalize(value) {
      return String(value || '')
        .toLocaleLowerCase('tr-TR')
        .replace(/ı/g, 'i')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function same(a, b) {
      return (
        String(a == null ? '' : a) ===
        String(b == null ? '' : b)
      );
    }

    function sameOptions(a, b) {
      return (
        Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every(function (value, index) {
          return same(value, b[index]);
        })
      );
    }

    function variantById(id) {
      return (
        variants.find(function (variant) {
          return (
            Number(variant.id) ===
            Number(id)
          );
        }) || null
      );
    }

    function variantByOptions(options) {
      return (
        variants.find(function (variant) {
          return variant.options.every(
            function (value, index) {
              return same(
                value,
                options[index]
              );
            }
          );
        }) || null
      );
    }

    function bestVariant(options, changedIndex) {
      const exact =
        variantByOptions(options);

      if (exact) return exact;

      return (
        variants
          .filter(function (variant) {
            return (
              changedIndex < 0 ||
              same(
                variant.options[changedIndex],
                options[changedIndex]
              )
            );
          })
          .map(function (variant) {
            let score =
              variant.available ? 0.25 : 0;

            variant.options.forEach(
              function (value, index) {
                if (
                  same(
                    value,
                    options[index]
                  )
                ) {
                  score +=
                    index === changedIndex
                      ? 10
                      : 1;
                }
              }
            );

            return {
              variant: variant,
              score: score
            };
          })
          .sort(function (a, b) {
            return b.score - a.score;
          })[0]?.variant || null
      );
    }

    function money(cents) {
      return (
        (
          Number(cents || 0) / 100
        ).toLocaleString('tr-TR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + ' ₺'
      );
    }

    function mainForm() {
      return (
        section.querySelector(
          'product-form form'
        ) ||
        section.querySelector(
          'form[action*="/cart/add"]'
        )
      );
    }

    function mainVariantInput() {
      const currentForm =
        mainForm();

      return currentForm
        ? currentForm.querySelector(
            'input[name="id"]'
          )
        : null;
    }

    function mainAddButton() {
      return (
        section.querySelector(
          'product-form button[name="add"]'
        ) ||
        section.querySelector(
          '.product-selector__submit'
        )
      );
    }

    function optionGroups() {
      const controls = Array.from(
        section.querySelectorAll(
          'select[name^="options["], ' +
          'input[type="radio"][name^="options["]'
        )
      ).filter(function (control) {
        return !bar.contains(control);
      });

      const names = [];

      controls.forEach(
        function (control) {
          if (
            control.name &&
            !names.includes(control.name)
          ) {
            names.push(control.name);
          }
        }
      );

      return names.map(
        function (name) {
          const items =
            controls.filter(
              function (control) {
                return (
                  control.name === name
                );
              }
            );

          return {
            name: name,

            selects: items.filter(
              function (item) {
                return (
                  item.tagName ===
                  'SELECT'
                );
              }
            ),

            radios: items.filter(
              function (item) {
                return (
                  item.tagName ===
                    'INPUT' &&
                  item.type ===
                    'radio'
                );
              }
            )
          };
        }
      );
    }

    function groupValue(group) {
      const checked =
        group.radios.find(
          function (radio) {
            return radio.checked;
          }
        );

      if (checked) {
        return checked.value;
      }

      const nonEmptySelect =
        group.selects.find(
          function (select) {
            return select.value;
          }
        );

      return nonEmptySelect
        ? nonEmptySelect.value
        : '';
    }

    function mainOptions() {
      return optionGroups().map(
        groupValue
      );
    }

    function optionIndexForControl(
      control
    ) {
      return optionGroups().findIndex(
        function (group) {
          return (
            group.name ===
            control.name
          );
        }
      );
    }

    function optionIndexForName(name) {
      const key = normalize(name);

      return optionGroups().findIndex(
        function (group) {
          return normalize(
            group.name
          ).includes(key);
        }
      );
    }

    function colorIndex() {
      const groups = optionGroups();

      for (
        let index = 0;
        index <
          variants[0].options.length;
        index += 1
      ) {
        const values = variants
          .map(function (variant) {
            return (
              variant.options[index]
            );
          })
          .join(' ');

        const text = normalize(
          (groups[index]?.name || '') +
          ' ' +
          values
        );

        if (
          text.includes('renk') ||
          text.includes('maden') ||
          text.includes('altin') ||
          text.includes('color') ||
          text.includes('tone') ||
          text.includes('sari') ||
          text.includes('rose') ||
          text.includes('beyaz') ||
          text.includes('yellow') ||
          text.includes('white')
        ) {
          return index;
        }
      }

      return -1;
    }

    function currentMainVariant() {
      const options =
        mainOptions();

      const byControls =
        variantByOptions(options);

      if (byControls) {
        return byControls;
      }

      const hidden =
        mainVariantInput();

      const byHidden = hidden
        ? variantById(
            hidden.value
          )
        : null;

      if (byHidden) {
        return byHidden;
      }

      return variantById(
        new URL(
          window.location.href
        ).searchParams.get(
          'variant'
        )
      );
    }

    function stickyOptions() {
      const result = [];

      stickySelects.forEach(
        function (select) {
          result[
            Number(
              select.dataset
                .kairosOptionIndex
            )
          ] = select.value;
        }
      );

      return result;
    }

    function stickyVariant() {
      return variantByOptions(
        stickyOptions()
      );
    }

    function cleanImageUrl(url) {
      if (!url) return '';

      let result =
        String(url).trim();

      if (
        result.indexOf('//') === 0
      ) {
        result =
          'https:' + result;
      }

      return result;
    }

    function variantImage(variant) {
      if (!variant) return '';

      const featuredImage =
        variant.featured_image;

      const featuredMedia =
        variant.featured_media;

      const variantImageValue =
        variant.image;

      if (
        typeof featuredImage ===
        'string'
      ) {
        return cleanImageUrl(
          featuredImage
        );
      }

      if (featuredImage?.src) {
        return cleanImageUrl(
          featuredImage.src
        );
      }

      if (featuredImage?.url) {
        return cleanImageUrl(
          featuredImage.url
        );
      }

      if (
        featuredMedia
          ?.preview_image
          ?.src
      ) {
        return cleanImageUrl(
          featuredMedia
            .preview_image.src
        );
      }

      if (
        featuredMedia
          ?.preview_image
          ?.url
      ) {
        return cleanImageUrl(
          featuredMedia
            .preview_image.url
        );
      }

      if (featuredMedia?.src) {
        return cleanImageUrl(
          featuredMedia.src
        );
      }

      if (featuredMedia?.url) {
        return cleanImageUrl(
          featuredMedia.url
        );
      }

      if (
        typeof variantImageValue ===
        'string'
      ) {
        return cleanImageUrl(
          variantImageValue
        );
      }

      if (variantImageValue?.src) {
        return cleanImageUrl(
          variantImageValue.src
        );
      }

      if (variantImageValue?.url) {
        return cleanImageUrl(
          variantImageValue.url
        );
      }

      return '';
    }

    function cssEscape(value) {
      const stringValue =
        String(
          value == null ? '' : value
        );

      if (
        window.CSS &&
        typeof window.CSS.escape ===
          'function'
      ) {
        return window.CSS.escape(
          stringValue
        );
      }

      return stringValue.replace(
        /([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g,
        '\\$1'
      );
    }

    function sourceFromImage(image) {
      if (!image) return '';

      return cleanImageUrl(
        image.currentSrc ||
        image.getAttribute('src') ||
        image.getAttribute(
          'data-src'
        ) ||
        ''
      );
    }

    function selectorImageForVariant(
      variant
    ) {
      if (
        !variant?.options?.length
      ) {
        return '';
      }

      for (
        let index = 0;
        index <
          variant.options.length;
        index += 1
      ) {
        const value =
          variant.options[index];

        const escapedValue =
          cssEscape(value);

        const image =
          section.querySelector(
            '[data-kairos-selector-value="' +
              escapedValue +
              '"] img, ' +
            '[data-kairos-stone="' +
              escapedValue +
              '"] img, ' +
            '[data-kairos-letter="' +
              escapedValue +
              '"] img'
          );

        const source =
          sourceFromImage(image);

        if (source) {
          return source;
        }
      }

      return '';
    }

    function mediaImageForVariant(
      variant
    ) {
      if (!variant) return '';

      const mediaIds = [
        variant.featured_media?.id,
        variant.featured_image?.id,
        variant.image?.id
      ].filter(Boolean);

      for (
        const mediaId of mediaIds
      ) {
        const escapedId =
          cssEscape(mediaId);

        const image =
          section.querySelector(
            '.product__media ' +
            '[data-media-id="' +
              escapedId +
              '"] img, ' +
            '.product__media ' +
            '[data-media-id$="-' +
              escapedId +
              '"] img'
          );

        const source =
          sourceFromImage(image);

        if (source) {
          return source;
        }
      }

      return '';
    }

    function activeMainMediaImage() {
      const selectors = [
        '.product__media ' +
          '.swiper-slide[data-selected] ' +
          '.media:not(.media--thumb) img',

        '.product__media ' +
          '.swiper-slide.is-active ' +
          '.media:not(.media--thumb) img',

        '.product__media ' +
          '.swiper-slide.swiper-slide-active ' +
          '.media:not(.media--thumb) img',

        '.product__media ' +
          '.product__gallery-opener.is-active img',

        '.product__media ' +
          '.media:not(.media--thumb) img'
      ];

      for (
        const selector of selectors
      ) {
        const source =
          sourceFromImage(
            section.querySelector(
              selector
            )
          );

        if (source) {
          return source;
        }
      }

      return '';
    }

    function ensureStickyImage() {
      let root =
        bar.querySelector(
          '[data-kairos-sticky-image]'
        ) ||
        bar.querySelector(
          '.kairos-sticky-atc__image'
        ) ||
        imageRoot;

      let image = null;

      if (
        root?.tagName === 'IMG'
      ) {
        image = root;
      } else if (root) {
        image =
          root.querySelector('img');
      }

      if (!image) {
        const summary =
          bar.querySelector(
            '.kairos-sticky-atc__summary'
          );

        if (!summary) {
          return null;
        }

        image =
          document.createElement(
            'img'
          );

        image.className =
          'kairos-sticky-atc__image';

        image.alt = '';

        summary.prepend(image);
      }

      image.setAttribute(
        'data-kairos-sticky-image',
        ''
      );

      image.loading = 'eager';
      image.decoding = 'async';

      return image;
    }

    function setStickyImageSource(
      image,
      url,
      variant
    ) {
      const cleanUrl =
        cleanImageUrl(url);

      if (!image || !cleanUrl) {
        return false;
      }

      const picture =
        image.closest('picture');

      if (picture) {
        picture
          .querySelectorAll(
            'source'
          )
          .forEach(
            function (source) {
              source.removeAttribute(
                'srcset'
              );

              source.removeAttribute(
                'data-srcset'
              );

              source.removeAttribute(
                'sizes'
              );
            }
          );
      }

      image.removeAttribute(
        'srcset'
      );

      image.removeAttribute(
        'data-srcset'
      );

      image.removeAttribute(
        'sizes'
      );

      image.setAttribute(
        'src',
        cleanUrl
      );

      image.setAttribute(
        'data-src',
        cleanUrl
      );

      image.alt =
        variant?.title ||
        variant?.name ||
        image.alt ||
        '';

      return true;
    }

    function updateStickyImage(
      variant,
      allowMainMediaFallback
    ) {
      if (!variant) return;

      const image =
        ensureStickyImage();

      if (!image) return;

      const directUrl =
        variantImage(variant) ||
        mediaImageForVariant(
          variant
        ) ||
        selectorImageForVariant(
          variant
        );

      if (directUrl) {
        setStickyImageSource(
          image,
          directUrl,
          variant
        );

        return;
      }

      if (
        allowMainMediaFallback !==
        false
      ) {
        const mainMediaUrl =
          activeMainMediaImage();

        if (mainMediaUrl) {
          setStickyImageSource(
            image,
            mainMediaUrl,
            variant
          );
        }
      }
    }

    function queueStickyImageUpdate(
      variant
    ) {
      updateStickyImage(
        variant,
        false
      );

      [40, 120, 280, 520].forEach(
        function (delay) {
          window.setTimeout(
            function () {
              updateStickyImage(
                variant,
                true
              );
            },
            delay
          );
        }
      );
    }

    function updateSticky(
      variant,
      savePreference
    ) {
      if (!variant) {
        submitButton.disabled = true;

        submitButton.textContent =
          'Seçenek Yok';

        return;
      }

      if (
        savePreference !== false
      ) {
        preferredOptions =
          variant.options.slice();
      }

      variantInput.value =
        variant.id;

      variant.options.forEach(
        function (value, index) {
          const select =
            stickySelects.find(
              function (item) {
                return (
                  Number(
                    item.dataset
                      .kairosOptionIndex
                  ) === index
                );
              }
            );

          if (!select) return;

          const option =
            Array.from(
              select.options
            ).find(
              function (item) {
                return same(
                  item.value,
                  value
                );
              }
            );

          if (option) {
            select.value =
              option.value;
          }
        }
      );

      if (
        priceEl &&
        variant.price != null
      ) {
        priceEl.textContent =
          money(variant.price);
      }

      queueStickyImageUpdate(
        variant
      );

      submitButton.disabled =
        !variant.available;

      submitButton.textContent =
        variant.available
          ? 'Sepete Ekle'
          : 'Tükendi';
    }

    function setGroup(group, value) {
      let dispatchControl = null;

      group.selects.forEach(
        function (select) {
          const option =
            Array.from(
              select.options
            ).find(
              function (item) {
                return same(
                  item.value,
                  value
                );
              }
            );

          if (option) {
            select.value =
              option.value;

            if (
              !dispatchControl
            ) {
              dispatchControl =
                select;
            }
          }
        }
      );

      group.radios.forEach(
        function (radio) {
          radio.checked =
            same(
              radio.value,
              value
            );

          if (radio.checked) {
            dispatchControl =
              radio;
          }
        }
      );

      return dispatchControl;
    }

    function setHiddenVariant(id) {
      const input =
        mainVariantInput();

      if (!input) return;

      input.value = id;

      input.setAttribute(
        'value',
        id
      );
    }

    function setVariantUrl(id) {
      const url = new URL(
        window.location.href
      );

      url.searchParams.set(
        'variant',
        id
      );

      window.history.replaceState(
        {},
        '',
        url.toString()
      );
    }

    function applyMainVariant(
      variant,
      changedIndex
    ) {
      if (
        !variant ||
        syncing
      ) {
        return;
      }

      syncing = true;

      preferredOptions =
        variant.options.slice();

      const localToken =
        ++token;

      function apply(
        dispatchEvent
      ) {
        if (
          localToken !== token
        ) {
          return;
        }

        const groups =
          optionGroups();

        const controls = [];

        groups.forEach(
          function (group, index) {
            controls[index] =
              setGroup(
                group,
                variant.options[index]
              );
          }
        );

        setHiddenVariant(
          variant.id
        );

        setVariantUrl(
          variant.id
        );

        if (!dispatchEvent) {
          return;
        }

        let dispatchIndex =
          changedIndex;

        const cIndex =
          colorIndex();

        /*
         * Renk değişiminden sonra son olayı
         * renk yerine beden kontrolünden göndeririz.
         */
        if (
          changedIndex === cIndex &&
          controls.length > 1
        ) {
          const nonColorIndexes =
            controls
              .map(
                function (
                  control,
                  index
                ) {
                  return (
                    control &&
                    index !== cIndex
                  )
                    ? index
                    : -1;
                }
              )
              .filter(
                function (index) {
                  return index > -1;
                }
              );

          if (
            nonColorIndexes.length
          ) {
            dispatchIndex =
              nonColorIndexes[
                nonColorIndexes.length -
                1
              ];
          }
        }

        const control =
          controls[dispatchIndex] ||
          controls[changedIndex] ||
          controls.find(Boolean);

        if (control) {
          control.dispatchEvent(
            new Event('input', {
              bubbles: true
            })
          );

          control.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        }
      }

      apply(true);

      setTimeout(
        function () {
          apply(false);
        },
        60
      );

      setTimeout(
        function () {
          apply(true);
        },
        180
      );

      setTimeout(
        function () {
          if (
            localToken !== token
          ) {
            return;
          }

          setHiddenVariant(
            variant.id
          );

          setVariantUrl(
            variant.id
          );

          updateSticky(
            variant,
            true
          );

          syncing = false;
        },
        380
      );
    }

    function queueIntent(
      index,
      value
    ) {
      if (
        syncing ||
        index < 0
      ) {
        return;
      }

      const sequence =
        ++token;

      lastIntentIndex =
        index;

      lastIntentAt =
        Date.now();

      pending = {
        sequence: sequence,
        index: index,
        value: value,
        base:
          preferredOptions.slice()
      };

      [0, 80, 220].forEach(
        function (delay) {
          setTimeout(
            function () {
              if (
                !pending ||
                pending.sequence !==
                  sequence ||
                syncing
              ) {
                return;
              }

              const current =
                mainOptions();

              const desired =
                pending.base.length
                  ? pending.base.slice()
                  : current.slice();

              while (
                desired.length <
                variants[0]
                  .options.length
              ) {
                desired.push('');
              }

              desired[index] =
                pending.value ||
                current[index];

              const selected =
                bestVariant(
                  desired,
                  index
                );

              if (!selected) {
                return;
              }

              pending = null;

              updateSticky(
                selected,
                true
              );

              const active =
                currentMainVariant();

              if (
                !active ||
                Number(active.id) !==
                  Number(
                    selected.id
                  ) ||
                !sameOptions(
                  mainOptions(),
                  selected.options
                )
              ) {
                applyMainVariant(
                  selected,
                  index
                );
              }
            },
            delay
          );
        }
      );
    }

    function reconcile() {
      if (
        syncing ||
        pending
      ) {
        return;
      }

      const current =
        mainOptions();

      const byControls =
        variantByOptions(current);

      if (
        !preferredOptions.length
      ) {
        const initial =
          byControls ||
          currentMainVariant();

        if (initial) {
          updateSticky(
            initial,
            true
          );
        }

        return;
      }

      if (
        current.length ===
          preferredOptions.length &&
        current.every(Boolean)
      ) {
        const changed = [];

        current.forEach(
          function (value, index) {
            if (
              !same(
                value,
                preferredOptions[index]
              )
            ) {
              changed.push(index);
            }
          }
        );

        if (!changed.length) {
          if (byControls) {
            updateSticky(
              byControls,
              false
            );
          }

          return;
        }

        if (
          changed.length === 1
        ) {
          const index =
            changed[0];

          const cIndex =
            colorIndex();

          /*
           * Renk seçiminden hemen sonra tema bedeni
           * gecikmeli olarak 5'e döndürürse bunu
           * gerçek kullanıcı seçimi olarak kabul etme.
           */
          if (
            lastIntentIndex ===
              cIndex &&
            index !== cIndex &&
            Date.now() -
              lastIntentAt <
              1400
          ) {
            const preserved =
              bestVariant(
                preferredOptions.slice(),
                cIndex
              );

            if (preserved) {
              updateSticky(
                preserved,
                true
              );

              applyMainVariant(
                preserved,
                cIndex
              );
            }

            return;
          }

          const desired =
            preferredOptions.slice();

          desired[index] =
            current[index];

          const selected =
            bestVariant(
              desired,
              index
            );

          if (selected) {
            updateSticky(
              selected,
              true
            );

            if (
              !byControls ||
              Number(
                byControls.id
              ) !==
                Number(
                  selected.id
                )
            ) {
              applyMainVariant(
                selected,
                index
              );
            }
          }

          return;
        }

        const cIndex =
          colorIndex();

        /*
         * Renk ve beden aynı anda değişmiş görünüyorsa
         * renk gerçek seçim, beden ise tema resetidir.
         */
        if (
          cIndex > -1 &&
          changed.includes(cIndex)
        ) {
          const desired =
            preferredOptions.slice();

          desired[cIndex] =
            current[cIndex];

          const selected =
            bestVariant(
              desired,
              cIndex
            );

          if (selected) {
            updateSticky(
              selected,
              true
            );

            applyMainVariant(
              selected,
              cIndex
            );

            return;
          }
        }
      }

      const fallback =
        byControls ||
        currentMainVariant();

      if (fallback) {
        updateSticky(
          fallback,
          true
        );
      }
    }

    /*
     * Sticky bar seçimi → ana ürün
     */
    stickySelects.forEach(
      function (select) {
        select.addEventListener(
          'change',
          function () {
            const selected =
              stickyVariant();

            if (!selected) {
              submitButton.disabled =
                true;

              submitButton.textContent =
                'Seçenek Yok';

              return;
            }

            const index =
              Number(
                select.dataset
                  .kairosOptionIndex
              );

            updateSticky(
              selected,
              true
            );

            applyMainVariant(
              selected,
              index
            );
          }
        );
      }
    );

    /*
     * Ana ürün select/radio değişimi → sticky bar
     */
    section.addEventListener(
      'change',
      function (event) {
        if (
          syncing ||
          event.target.closest(
            '[data-kairos-sticky-atc]'
          )
        ) {
          return;
        }

        const target =
          event.target;

        if (
          target.matches(
            'select[name^="options["], ' +
            'input[type="radio"][name^="options["]'
          )
        ) {
          if (
            target.type ===
              'radio' &&
            !target.checked
          ) {
            return;
          }

          queueIntent(
            optionIndexForControl(
              target
            ),
            target.value
          );
        } else {
          setTimeout(
            reconcile,
            60
          );

          setTimeout(
            reconcile,
            200
          );
        }
      },
      true
    );

    /*
     * Özel altın tonu ve premium selector butonları
     */
    section.addEventListener(
      'click',
      function (event) {
        if (
          syncing ||
          event.target.closest(
            '[data-kairos-sticky-atc]'
          )
        ) {
          return;
        }

        const toneButton =
          event.target.closest(
            '[data-kairos-tone]'
          );

        if (toneButton) {
          const index =
            colorIndex();

          setTimeout(
            function () {
              const values =
                mainOptions();

              queueIntent(
                index,
                values[index]
              );
            },
            0
          );

          return;
        }

        const selectorButton =
          event.target.closest(
            '[data-kairos-selector-value]'
          );

        if (selectorButton) {
          const root =
            selectorButton.closest(
              '[data-kairos-premium-selector]'
            );

          queueIntent(
            root
              ? optionIndexForName(
                  root.getAttribute(
                    'data-option-name'
                  )
                )
              : -1,

            selectorButton.getAttribute(
              'data-kairos-selector-value'
            )
          );
        }
      },
      true
    );

    /*
     * Tema varyantı sessizce değiştirirse yakalar.
     */
    const watcher =
      setInterval(
        reconcile,
        180
      );

    function showSticky(show) {
      bar.classList.toggle(
        'is-visible',
        show
      );

      if (show) {
        reconcile();
      }
    }

    const addButton =
      mainAddButton();

    if (
      'IntersectionObserver' in
        window &&
      addButton
    ) {
      observer =
        new IntersectionObserver(
          function (entries) {
            showSticky(
              !entries[0]
                .isIntersecting &&
              window.scrollY > 260
            );
          },
          {
            threshold: 0.1
          }
        );

      observer.observe(
        addButton
      );
    } else {
      window.addEventListener(
        'scroll',
        function () {
          showSticky(
            window.scrollY > 520
          );
        },
        {
          passive: true
        }
      );
    }

    /*
     * Sticky bardan sepete ekleme
     */
    form.addEventListener(
      'submit',
      async function (event) {
        event.preventDefault();

        const selected =
          stickyVariant() ||
          variantById(
            variantInput.value
          ) ||
          currentMainVariant();

        if (
          !selected ||
          !selected.available
        ) {
          submitButton.disabled =
            true;

          submitButton.textContent =
            'Seçenek Yok';

          return;
        }

        variantInput.value =
          selected.id;

        submitButton.disabled =
          true;

        submitButton.textContent =
          'Ekleniyor...';

        try {
          const data =
            new FormData(form);

          data.set(
            'id',
            selected.id
          );

          const response =
            await fetch(
              '/cart/add.js',
              {
                method: 'POST',
                body: data,
                headers: {
                  Accept:
                    'application/json'
                }
              }
            );

          if (!response.ok) {
            throw new Error(
              'Sepete eklenemedi'
            );
          }

          submitButton.textContent =
            'Sepete Eklendi';

          document.dispatchEvent(
            new CustomEvent(
              'cart:refresh'
            )
          );

          document.dispatchEvent(
            new CustomEvent(
              'cart:updated'
            )
          );

          window.dispatchEvent(
            new CustomEvent(
              'cart:refresh'
            )
          );

          setTimeout(
            function () {
              submitButton.disabled =
                false;

              submitButton.textContent =
                'Sepete Ekle';
            },
            1500
          );
        } catch (error) {
          console.error(
            'Kairos sticky sepet hatası:',
            error
          );

          submitButton.textContent =
            'Tekrar Dene';

          setTimeout(
            function () {
              submitButton.disabled =
                false;

              submitButton.textContent =
                'Sepete Ekle';
            },
            1800
          );
        }
      }
    );

    /*
     * İlk açılış
     */
    const initial =
      currentMainVariant() ||
      variantById(
        variantInput.value
      ) ||
      variants[0];

    if (initial) {
      updateSticky(
        initial,
        true
      );
    }

    window.addEventListener(
      'pageshow',
      function () {
        setTimeout(
          reconcile,
          0
        );

        setTimeout(
          reconcile,
          200
        );
      }
    );

    window.addEventListener(
      'popstate',
      function () {
        setTimeout(
          reconcile,
          0
        );

        setTimeout(
          reconcile,
          200
        );
      }
    );

    window.addEventListener(
      'beforeunload',
      function () {
        clearInterval(
          watcher
        );

        if (observer) {
          observer.disconnect();
        }
      },
      {
        once: true
      }
    );
  }
});